var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgSuccess = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 18 18"
}, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
  fill: "#52C16B"
}, /*#__PURE__*/React.createElement("path", {
  d: "M9 0C4.037 0 0 4.037 0 9s4.037 9 9 9 9-4.037 9-9c0-4.962-4.037-9-9-9m0 16.364c-4.06 0-7.364-3.304-7.364-7.364S4.94 1.636 9 1.636 16.364 4.94 16.364 9 13.06 16.364 9 16.364"
}), /*#__PURE__*/React.createElement("path", {
  d: "M5.101 9.85C5.034 9.78 5 9.675 5 9.605s.034-.175.101-.245l.471-.49a.317.317 0 0 1 .471 0l.034.035 1.85 2.065c.068.07.17.07.236 0l4.51-4.865h.034a.317.317 0 0 1 .47 0l.472.49c.135.14.135.35 0 .49l-5.385 5.81c-.067.07-.134.105-.235.105s-.168-.035-.236-.105l-2.625-2.94z"
}))));
export default SvgSuccess;